// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*imports*/
.container {
  display: flex;
  justify-content: space-around;
  background: #FFFFFF;
}
.container .view__container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 80%;
}
.container .view__header {
  display: flex;
  font-size: 16px;
  color: #10069F;
  letter-spacing: 0;
  margin: 2em 0 0.5em;
  justify-content: space-between;
  line-height: 1;
}
.container .view__section {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 16px;
}
.container .view__section--column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.container .view__section--header {
  width: 20%;
}
.container .view__section--header span {
  font-size: 14px;
  line-height: 1;
  color: #575756;
  letter-spacing: 0;
}
.container .view__section--body {
  width: 40%;
  padding-right: 12%;
}
.container .view__section--body-label {
  font-size: 12px;
  margin-bottom: 10px;
  color: #696969;
  line-height: 1;
}
.container .view__section--body-value {
  font-size: 14px;
  line-height: 1.5;
  color: #282828;
  max-height: 18px;
  width: 100%;
  display: block;
  position: relative;
}
.container .view__section--body-value input[type=text],
.container .view__section--body-value input[type=password],
.container .view__section--body-value ng-select {
  border: none;
  color: #282828;
  font-size: 14px;
  margin: 0;
  padding: 0;
  font-family: "FSAlbertArabic-Regular";
  float: left;
  height: 100%;
  line-height: 1;
}
.container .view__section--body-value input[type=text]:not(.disabled),
.container .view__section--body-value input[type=password]:not(.disabled),
.container .view__section--body-value ng-select:not(.disabled) {
  border-bottom: 1px solid #696969;
  max-height: inherit;
}
@media not all and (min-resolution: 0.001dpcm) {
  .container .view__section--body-value input[type=text]:not(.disabled),
  .container .view__section--body-value input[type=password]:not(.disabled),
  .container .view__section--body-value ng-select:not(.disabled) {
    max-height: 25px;
    height: 25px;
  }
}
.container .view__section--body-value ng-select {
  height: 18px;
}
.container .view__section--body-value language-dropdown,
.container .view__section--body-value .flag-holder {
  height: inherit;
}
.container .view__section--body-value language-dropdown,
.container .view__section--body-value input[type=text], .container .view__section--body-value input[type=password],
.container .view__section--body-value ng-select {
  width: 100%;
}
.container .view__section--body-value .partial-disabled {
  border-bottom: 1px solid #696969;
  cursor: not-allowed;
  pointer-events: none;
}
.container .view__section--body-value .fa-upload,
.container .view__section--body-value .fa-download {
  position: absolute;
  right: 0.4em;
  bottom: 3px;
  color: #10069F;
  cursor: pointer;
}
.container .view__section--body-value .custom-file-upload {
  border: none;
  padding: 0px;
  background: none;
}
.container .view__section--body-value-wrap {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
}
.container .view__section--body-error {
  margin: 0px;
  color: #FF0000;
  font-size: 12px;
  margin-top: 10px;
}
.container .view__section--body-error span {
  display: block;
  line-height: 1;
}
.container .view__section .fa-upload,
.container .view__section .fa-download {
  color: #10069F;
}
.container .view__section .hierarchy-dropdown {
  width: 80%;
  display: flex;
}
.container .view__section--button {
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin: 10px 0 5em;
}
.container .view__section--button-wrapper {
  display: flex;
  flex-grow: 1;
}
.container .view__section--button-wrapper:not(:first-child), .container .view__section--button-wrapper:first-child:last-child {
  justify-content: flex-end;
}
.container .btn {
  width: auto;
  margin-right: 10px;
  text-transform: uppercase;
  background: transparent;
  font-family: "FSAlbertArabic-Bold";
  cursor: pointer;
  font-size: 12px;
  padding: 8px 20px 4px;
  color: #10069F;
  border: 1px solid #10069F;
  line-height: 1;
  transition: all 0.2s ease;
}
.container .btn:last-child {
  margin-right: 0;
}
.container .btn:hover {
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
}
.container .btn.disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid #a7a9ac;
  background-color: #a7a9ac;
  pointer-events: none;
  color: #FFFFFF;
}
.container .btn-save {
  background-color: #10069F;
  color: #FFFFFF;
}
.container.add-edit-page {
  background: #F3F2FA;
}
.container.add-edit-page .view__section:not(.view__section--button) {
  background-color: #FFFFFF;
  padding: 20px 50px 0px 50px;
  margin-bottom: 10px;
}
.container.add-edit-page .view__header {
  padding: 0px 50px 0px 50px;
}

.select-dropdown-arrow.active:after, .active.select-dropdown:after {
  transition: 0.5s all cubic-bezier(0.18, 0.89, 0.32, 1.28);
  transform: rotate(180deg);
}
.select-dropdown-arrow:after, .select-dropdown:after {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #10069F;
  position: absolute;
  top: 40%;
  right: 3%;
  transition: 0.4s all cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.select-dropdown {
  position: relative;
  width: 100%;
  cursor: pointer;
  display: flex;
  border-bottom: 1px solid #696969;
  height: 18px;
}
@media not all and (min-resolution: 0.001dpcm) {
  .select-dropdown {
    height: 25px;
  }
}
.select-dropdown .label {
  color: #282828;
  font-size: 14px;
  padding-right: 3em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  line-height: 1;
}
.select-dropdown .label-placeholder {
  font-size: 12px;
  color: #696969;
}
.select-dropdown .select-label {
  position: relative;
  background: #F3F2FA;
}
.select-dropdown .select-label input[type=search] {
  padding: 8px 8px 8px 30px;
  margin: 0;
  font-size: 12px;
  width: 100%;
  border: none;
  background: #F3F2FA;
  appearance: none;
  line-height: 1;
}
.select-dropdown .fa-search {
  position: absolute;
  left: 8px;
  top: 22%;
  color: #696969;
  font-size: 13px;
}
.select-dropdown.active .select-dropdown-wrapper {
  display: block;
}
.select-dropdown .select-dropdown-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  width: 100%;
  background: #FFFFFF;
  font-weight: normal;
  box-shadow: 0px 3px 3px 1px rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  z-index: 10;
  width: 100%;
  left: 0;
  top: 100%;
}
.select-dropdown .fixed-height {
  height: auto;
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.select-dropdown .select-item {
  padding: 10px 10px 8px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
}
.select-dropdown .select-item:hover {
  background-color: #F3F2FA;
}
.select-dropdown .select-item label {
  font-size: 14px;
  word-wrap: break-word;
  display: block;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

input::-webkit-input-placeholder {
  font-size: 12px;
}

input::-moz-placeholder {
  font-size: 12px;
}

input::-ms-input-placeholder {
  font-size: 12px;
}

.cookie-consent-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  flex-direction: row;
  font-family: "FSAlbertArabic-Regular";
}

button {
  cursor: pointer;
}

.cookie-consent-option-popup {
  position: fixed;
  bottom: 2em;
  right: 0;
  left: 5em;
  transform: translateX(-50%);
  left: 50%;
  z-index: 10001;
  background-color: #fff;
  width: 80%;
  border-radius: 6.5px;
  padding: 20px 0;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
  display: flex;
}
@media (max-width: 991px) {
  .cookie-consent-option-popup {
    flex-direction: column;
    padding-right: 10px;
  }
}
@media (max-width: 586px) {
  .cookie-consent-option-popup {
    width: 100%;
  }
}
@media (max-width: 991px) {
  .cookie-consent-option-popup .cookie-consent-description {
    width: 100%;
  }
}
.cookie-consent-option-popup .cookie-consent-description p {
  margin: 0 0 1em 0;
  margin-left: 10px;
  font-family: inherit;
  clear: both;
  float: left;
  margin-bottom: 0;
  padding-bottom: 0px;
  font-size: 1.4rem;
  line-height: 1.5;
}
.cookie-consent-option-popup .cookie-consent-description p a {
  text-decoration: underline;
  color: #10069f;
}
.cookie-consent-option-popup .cookie-consent-option-btns {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin-left: 10px;
  width: 25%;
}
@media (max-width: 991px) {
  .cookie-consent-option-popup .cookie-consent-option-btns {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }
}
.cookie-consent-option-popup .cookie-consent-option-btns .btn {
  width: auto;
  margin-right: 10px;
  background: transparent;
  font-family: "FSAlbertArabic-Regular";
  cursor: pointer;
  font-size: 1.4rem;
  padding: 8px 20px 4px;
  border-radius: 25px;
  line-height: 1;
  transition: all 0.2s ease;
  padding: 13px;
  font-weight: bold;
}
.cookie-consent-option-popup .cookie-consent-option-btns .btn-accept-all {
  margin-bottom: 5px;
  background-color: #10069f;
  color: #fff;
  border: 1px solid #10069f;
}
.cookie-consent-option-popup .cookie-consent-option-btns .btn-customize {
  background-color: #fff;
  color: #10069f;
  border: 1px solid #10069f;
}

.cookie-consent-customize-popup {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  z-index: 10001;
  background-color: #fff;
  width: 60%;
  border-radius: 6.5px;
  padding: 20px 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  max-height: 80%;
}
@media (max-width: 1200px) {
  .cookie-consent-customize-popup {
    width: 70%;
  }
}
@media (max-width: 991px) {
  .cookie-consent-customize-popup {
    width: 80%;
  }
}
@media (max-width: 586px) {
  .cookie-consent-customize-popup {
    width: 100%;
  }
}

.cookie-consent-custom-header {
  border-bottom: 1px solid #f4f5f7;
  padding: 0px 20px;
}
@media (max-width: 991px) {
  .cookie-consent-custom-header {
    padding: 0px 10px;
  }
}
@media (max-width: 586px) {
  .cookie-consent-custom-header {
    padding: 0px 5px;
  }
}

.arrow {
  border: solid #2d4156;
  border-width: 0 2px 2px 0;
  padding: 0.2em;
  display: inline-block;
  content: "";
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 5px;
}

.down {
  transform: translateY(-0.2em) rotate(45deg);
}

.up {
  transform: translateY(0.05em) rotate(225deg);
}

.cookie-consent-custom-body {
  overflow: scroll;
  padding: 0px 20px;
}
@media (max-width: 991px) {
  .cookie-consent-custom-body {
    padding: 0px 10px;
  }
}
@media (max-width: 586px) {
  .cookie-consent-custom-body {
    padding: 0px 5px;
  }
}

.accordion-content {
  margin-bottom: 15px;
}

.accordion-header {
  background-color: #f0f4f7;
  height: 50px;
  padding-left: 10px;
  cursor: pointer;
}

.accordion-header-name {
  font-size: 1.5rem;
  font-weight: bold;
}

.switch {
  position: relative;
  width: 60px;
  height: 34px;
  float: right;
  margin-top: 8px;
  margin-right: 10px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #7d7d7d;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #10069f;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(25px);
}

input:disabled {
  opacity: 0.4;
  cursor: not-allowed !important;
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed !important;
}

/*------ ADDED CSS ---------*/
.on {
  display: none;
}

.on,
.off {
  color: white;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  font-size: 10px;
  font-family: Verdana, sans-serif;
}

input:checked + .slider .on {
  display: block;
}

input:checked + .slider .off {
  display: none;
}

/*--------- END --------*/
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.accordion-body {
  background-color: #f0f4f7;
  padding-top: 2px;
  padding-left: 10px;
  padding-bottom: 10px;
  overflow-x: scroll;
}
.accordion-body table {
  margin-top: 25px;
  border-collapse: collapse;
}
.accordion-body tr:nth-child(odd) {
  background-color: #e5ebef;
}
.accordion-body tr td,
.accordion-body tr th {
  border-bottom: 1px solid #d2caca;
  border: 1px solid #d2caca;
}
.accordion-body th {
  text-align: left;
  border-bottom: 1px solid #e9edf2;
  font-weight: normal;
  padding-bottom: 5px;
  padding: 10px 5px;
  font-weight: bold;
}
.accordion-body td {
  padding-bottom: 5px;
  padding: 10px 5px;
}

.cookie-consent-custom-footer {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0px 20px;
}
@media (max-width: 991px) {
  .cookie-consent-custom-footer {
    padding: 20px 10px 0px 10px;
  }
}
@media (max-width: 586px) {
  .cookie-consent-custom-footer {
    padding: 20px 10px 0px 10px;
  }
}

.btn {
  font-family: FSAlbertArabic-Bold;
  line-height: 1;
  padding: 10px 30px 7px 30px;
  font-size: 1.6rem;
  text-transform: uppercase;
  border-radius: 0;
  color: #fff;
  border: none;
  font-weight: 300;
  cursor: pointer;
  border-radius: 5px;
}

.allow-all-btn {
  cursor: pointer;
  background-color: #10069f;
}

.allow-selection-btn {
  cursor: pointer;
  border: 1px solid #10069f;
  background-color: #fff;
  color: #10069f;
}`, "",{"version":3,"sources":["webpack://./src/app/base/components/app-custom-cookie-consent/app-custom-cookie-consent.component.scss","webpack://./src/scss/_forms_new.scss","webpack://./src/scss/_mixins.scss","webpack://./src/scss/_config.scss"],"names":[],"mappings":"AAAA,UAAA;ACIA;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;ADFJ;ACIQ;ECNJ,aAAA;EAWI,sBDJkB;EACd,6BAAA;EACA,UAAA;ADDZ;ACGQ;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;ADDZ;ACGQ;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;ADDZ;ACEY;ECzBR,aAAA;EAWI,sBDesB;EACd,oBAAA;ADChB;ACCY;EACI,UAAA;ADChB;ACAgB;EACI,eAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;ADEpB;ACCY;EACI,UAAA;EACA,kBAAA;ADChB;ACAgB;EACI,eAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;ADEpB;ACCgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;ADCpB;ACAoB;;;EAGI,YAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qCE3BO;EF4BP,WAAA;EACA,YAAA;EACA,cAAA;ADExB;ACDwB;;;EACI,gCAAA;EACA,mBAAA;ADK5B;ACJ4B;EAHJ;;;IAIQ,gBAAA;IACA,YAAA;EDS9B;AACF;ACNoB;EACI,YAAA;ADQxB;ACNoB;;EAEI,eAAA;ADQxB;ACNoB;;;EAGI,WAAA;ADQxB;ACNoB;EACI,gCAAA;EACA,mBAAA;EACA,oBAAA;ADQxB;ACNoB;;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;ADQxB;ACNoB;EACI,YAAA;EACA,YAAA;EACA,gBAAA;ADQxB;ACLgB;EACI,mBAAA;EC7GhB,aAAA;EAWI,sBDmG0B;ADQlC;ACNgB;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ADQpB;ACPoB;EACI,cAAA;EACA,cAAA;ADSxB;ACLY;;EAEI,cAAA;ADOhB;ACLY;EACI,UAAA;EACA,aAAA;ADOhB;ACLY;EACI,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;ADOhB;ACNgB;EACI,aAAA;EACA,YAAA;ADQpB;ACPoB;EAEI,yBAAA;ADQxB;ACFI;EACI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kCEhHoB;EFiHpB,eAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;ADIR;ACHQ;EACI,eAAA;ADKZ;ACHQ;EACI,0CAAA;ADKZ;ACHQ;EACI,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,oBAAA;EACA,cAAA;ADKZ;ACFI;EACI,yBAAA;EACA,cAAA;ADIR;ACFI;EACI,mBAAA;ADIR;ACHQ;EACI,yBAAA;EACA,2BAAA;EACA,mBAAA;ADKZ;ACHQ;EACI,0BAAA;ADKZ;;ACEQ;EACI,yDAAA;EACA,yBAAA;ADCZ;ACEI;EACI,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yDAAA;ADAR;;ACIA;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EAEA,gCAAA;EACA,YAAA;ADFJ;ACGI;EARJ;IASQ,YAAA;EDAN;AACF;ACCI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;ADCR;ACCI;EACI,eAAA;EACA,cAAA;ADCR;ACCI;EACI,kBAAA;EACA,mBAAA;ADCR;ACAQ;EACI,yBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;ADEZ;ACCI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;ADCR;ACEQ;EACI,cAAA;ADAZ;ACGI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,yCAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;ADDR;ACGI;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ADDR;ACGI;EACI,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;ADDR;ACEQ;EACI,yBAAA;ADAZ;ACEQ;EACI,eAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;ADAZ;;ACKA;EACI,eAAA;ADFJ;;ACKA;EACI,eAAA;ADFJ;;ACKA;EACI,eAAA;ADFJ;;AApTA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,8BAAA;EACA,cAAA;EEbE,aAAA;EAWI,mBAZgB;EFgBtB,qCGsB6B;AHkS/B;;AArTA;EACE,eAAA;AAwTF;;AArTA;EACE,eAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,oBAAA;EACA,eAAA;EAGA,uCAAA;EACA,aAAA;AAwTF;AAtTE;EAjBF;IAkBI,sBAAA;IACA,mBAAA;EAyTF;AACF;AAvTE;EAtBF;IAuBI,WAAA;EA0TF;AACF;AAvTI;EADF;IAEI,WAAA;EA0TJ;AACF;AAxTI;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA0TN;AAxTM;EACE,0BAAA;EACA,cAAA;AA0TR;AArTE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,UAAA;AAuTJ;AAtTI;EANF;IAOI,WAAA;IACA,mBAAA;IACA,8BAAA;EAyTJ;AACF;AAvTI;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,qCGlDyB;EHmDzB,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;AAyTN;AAvTI;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;AAyTN;AAvTI;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;AAyTN;;AApTA;EACE,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EAGA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;AAuTF;AArTE;EAlBF;IAmBI,UAAA;EAwTF;AACF;AAvTE;EArBF;IAsBI,UAAA;EA0TF;AACF;AAzTE;EAxBF;IAyBI,WAAA;EA4TF;AACF;;AAzTA;EACE,gCAAA;EACA,iBAAA;AA4TF;AA1TE;EAJF;IAKI,iBAAA;EA6TF;AACF;AA5TE;EAPF;IAQI,gBAAA;EA+TF;AACF;;AA7TA;EACE,qBAAA;EAEA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA+TF;;AA7TA;EACE,2CAAA;AAgUF;;AA9TA;EACE,4CAAA;AAiUF;;AA/TA;EACE,gBAAA;EACA,iBAAA;AAkUF;AAjUE;EAHF;IAII,iBAAA;EAoUF;AACF;AAnUE;EANF;IAOI,gBAAA;EAsUF;AACF;;AAnUA;EACE,mBAAA;AAsUF;;AAnUA;EACE,yBAAA;EACA,YAAA;EAEA,kBAAA;EACA,eAAA;AAqUF;;AAlUA;EACE,iBAAA;EACA,iBAAA;AAqUF;;AAlUA;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAoUF;;AAjUA;EACE,aAAA;AAoUF;;AAjUA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAEA,yBAAA;EAEA,gBAAA;AAmUF;;AAhUA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;AAmUF;;AAhUA;EAEE,yBAAA;AAkUF;;AA/TA;EACE,2BAAA;AAkUF;;AA/TA;EAGE,2BAAA;AAkUF;;AAhUA;EACE,YAAA;EACA,8BAAA;AAmUF;;AAjUA;EACE,YAAA;EACA,8BAAA;AAoUF;;AAlUA,6BAAA;AACA;EACE,aAAA;AAqUF;;AAlUA;;EAEE,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AAqUF;;AA/TA;EACE,cAAA;AAkUF;;AA/TA;EACE,aAAA;AAkUF;;AA/TA,yBAAA;AAEA,oBAAA;AACA;EACE,mBAAA;AAiUF;;AA9TA;EACE,kBAAA;AAiUF;;AA9TA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;AAiUF;AA/TE;EACE,gBAAA;EACA,yBAAA;AAiUJ;AA5TE;EACE,yBAAA;AA8TJ;AA5TE;;EAEE,gCAAA;EACA,yBAAA;AA8TJ;AA5TE;EACE,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AA8TJ;AA5TE;EACE,mBAAA;EACA,iBAAA;AA8TJ;;AA3TA;EACE,aAAA;EACA,8BAAA;EAGA,2BAAA;AA4TF;AA3TE;EANF;IAOI,2BAAA;EA8TF;AACF;AA7TE;EATF;IAUI,2BAAA;EAgUF;AACF;;AA9TA;EACE,gCAAA;EACA,cAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAgUF;;AA7TA;EACE,eAAA;EACA,yBAAA;AAgUF;;AA9TA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAiUF","sourcesContent":["/*imports*/\n@import \"../../../../scss/config\";\n@import \"../../../../scss/mixins\";\n@import \"../../../../scss/colors\";\n@import \"../../../../scss/forms_new\";\n\n.cookie-consent-container {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n  @include flex();\n  font-family: $font-family-fsalbert-regular;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.cookie-consent-option-popup {\n  position: fixed;\n  bottom: 2em;\n  right: 0;\n  left: 5em;\n  transform: translateX(-50%);\n  left: 50%;\n  z-index: 10001;\n  background-color: #fff;\n  width: 80%;\n  border-radius: 6.5px;\n  padding: 20px 0;\n  -webkit-box-shadow: 0 0 18px rgb(0, 0, 0, 0.20);\n  -moz-box-shadow: 0 0 18px rgba(185, 169, 169, 0.2);\n  box-shadow: 0 0 18px rgb(0, 0, 0, 0.20);\n  display: flex;\n\n  @media (max-width: 991px) {\n    flex-direction: column;\n    padding-right: 10px;\n  }\n  \n  @media (max-width: 586px) {\n    width: 100%;\n  }\n\n  .cookie-consent-description {\n    @media (max-width: 991px) {\n      width: 100%;\n    }\n\n    p {\n      margin: 0 0 1em 0;\n      margin-left: 10px;\n      font-family: inherit;\n      clear: both;\n      float: left;\n      margin-bottom: 0;\n      padding-bottom: 0px;\n      font-size: 1.4rem;\n      line-height: 1.5;\n\n      a {\n        text-decoration: underline;\n        color: #10069f;\n      }\n    }\n  }\n\n  .cookie-consent-option-btns {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    margin-left: 10px;\n    width: 25%;\n    @media (max-width: 991px) {\n      width: 100%;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n\n    .btn {\n      width: auto;\n      margin-right: 10px;\n      background: transparent;\n      font-family: $font-family-fsalbert-regular;\n      cursor: pointer;\n      font-size: 1.4rem;\n      padding: 8px 20px 4px;\n      border-radius: 25px;\n      line-height: 1;\n      transition: all 0.2s ease;\n      padding: 13px;\n      font-weight: bold;\n    }\n    .btn-accept-all {\n      margin-bottom: 5px;\n      background-color: #10069f;\n      color: #fff;\n      border: 1px solid #10069f;\n    }\n    .btn-customize {\n      background-color: #fff;\n      color: #10069f;\n      border: 1px solid #10069f;\n    }\n  }\n}\n\n.cookie-consent-customize-popup {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  left: 50%;\n  z-index: 10001;\n  background-color: #fff;\n  width: 60%;\n  border-radius: 6.5px;\n  padding: 20px 10px;\n  -webkit-box-shadow: 0 0 18px rgb(0, 0, 0, 0.20);\n  -moz-box-shadow: 0 0 18px rgba(185, 169, 169, 0.2);\n  box-shadow: 0 0 18px rgb(0, 0, 0, 0.20);\n  display: flex;\n  flex-direction: column;\n  font-size: 1.4rem;\n  max-height: 80%;\n  //   overflow: scroll;\n  @media (max-width: 1200px) {\n    width: 70%;\n  }\n  @media (max-width: 991px) {\n    width: 80%;\n  }\n  @media (max-width: 586px) {\n    width: 100%;\n  }\n}\n\n.cookie-consent-custom-header {\n  border-bottom: 1px solid #f4f5f7;\n  padding: 0px 20px;\n\n  @media (max-width: 991px) {\n    padding: 0px 10px;\n  }\n  @media (max-width: 586px) {\n    padding: 0px 5px;\n  }\n}\n.arrow {\n  border: solid #2d4156;\n  // border-color: var(--cc-btn-secondary-text);\n  border-width: 0 2px 2px 0;\n  padding: 0.2em;\n  display: inline-block;\n  content: \"\";\n  margin-top: 20px;\n  margin-right: 15px;\n  margin-left: 5px;\n}\n.down {\n  transform: translateY(-0.2em) rotate(45deg);\n}\n.up {\n  transform: translateY(0.05em) rotate(225deg);\n}\n.cookie-consent-custom-body {\n  overflow: scroll;\n  padding: 0px 20px;\n  @media (max-width: 991px) {\n    padding: 0px 10px;\n  }\n  @media (max-width: 586px) {\n    padding: 0px 5px;\n  }\n}\n\n.accordion-content {\n  margin-bottom: 15px;\n}\n\n.accordion-header {\n  background-color: #f0f4f7;\n  height: 50px;\n  //   padding: 20px;\n  padding-left: 10px;\n  cursor: pointer;\n}\n\n.accordion-header-name {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.switch {\n  position: relative;\n  //   display: inline-block;\n  width: 60px;\n  height: 34px;\n  float: right;\n  margin-top: 8px;\n  margin-right: 10px;\n}\n\n.switch input {\n  display: none;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  //   background-color: #ca2222;\n  background-color: #7d7d7d;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  //   background-color: #2ab934;\n  background-color: #10069f;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(25px);\n  -ms-transform: translateX(25px);\n  transform: translateX(25px);\n}\ninput:disabled {\n  opacity: 0.4;\n  cursor: not-allowed !important;\n}\n.disabled {\n  opacity: 0.4;\n  cursor: not-allowed !important;\n}\n/*------ ADDED CSS ---------*/\n.on {\n  display: none;\n}\n\n.on,\n.off {\n  color: white;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  font-size: 10px;\n  font-family: Verdana, sans-serif;\n}\n// .off {\n//     padding-left: 10px;\n//     font-size: 14px;\n// }\ninput:checked + .slider .on {\n  display: block;\n}\n\ninput:checked + .slider .off {\n  display: none;\n}\n\n/*--------- END --------*/\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.accordion-body {\n  background-color: #f0f4f7;\n  padding-top: 2px;\n  padding-left: 10px;\n  padding-bottom: 10px;\n  overflow-x: scroll;\n\n  table {\n    margin-top: 25px;\n    border-collapse: collapse;\n  }\n  tr:hover {\n    // background-color: #e5ebef;\n  }\n  tr:nth-child(odd) {\n    background-color: #e5ebef;\n  }\n  tr td,\n  tr th {\n    border-bottom: 1px solid #d2caca;\n    border: 1px solid #d2caca;\n  }\n  th {\n    text-align: left;\n    border-bottom: 1px solid #e9edf2;\n    font-weight: normal;\n    padding-bottom: 5px;\n    padding: 10px 5px;\n    font-weight: bold;\n  }\n  td {\n    padding-bottom: 5px;\n    padding: 10px 5px;\n  }\n}\n.cookie-consent-custom-footer {\n  display: flex;\n  justify-content: space-between;\n  // padding: 0px 20px;\n  // padding-top: 20px;\n  padding: 20px 20px 0px 20px;\n  @media (max-width: 991px) {\n    padding: 20px 10px 0px 10px;\n  }\n  @media (max-width: 586px) {\n    padding: 20px 10px 0px 10px;\n  }\n}\n.btn {\n  font-family: FSAlbertArabic-Bold;\n  line-height: 1;\n  // padding-top: 8px;\n  padding: 10px 30px 7px 30px;\n  font-size: 1.6rem;\n  text-transform: uppercase;\n  border-radius: 0;\n  color: #fff;\n  border: none;\n  font-weight: 300;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.allow-all-btn {\n  cursor: pointer;\n  background-color: #10069f;\n}\n.allow-selection-btn {\n  cursor: pointer;\n  border: 1px solid #10069f;\n  background-color: #fff;\n  color: #10069f;\n}\n// th{\n\n// }\n","@import 'config';\n@import 'mixins';\n@import 'colors';\n\n.container {\n    display: flex;\n    justify-content: space-around;\n    background: color_new(white, base);\n    .view {\n        &__container {\n            @include flex(column);\n            justify-content: space-around;\n            width: 80%;\n        }\n        &__header {\n            display: flex;\n            font-size: 16px;\n            color: color_new(blue, diversey_blue);\n            letter-spacing: 0;\n            margin: 2em 0 0.5em;\n            justify-content: space-between;\n            line-height: 1;\n        }\n        &__section {\n            display: flex;\n            flex-wrap: wrap;\n            width: 100%;\n            margin-bottom: 16px;\n            &--column {\n                @include flex(column);\n                align-items: stretch;\n            }\n            &--header {\n                width: 20%;\n                span {\n                    font-size: 14px;\n                    line-height: 1;\n                    color: color_new(grey, dark);\n                    letter-spacing: 0;\n                }\n            }\n            &--body {\n                width: 40%;\n                padding-right: 12%;\n                &-label {\n                    font-size: 12px;\n                    margin-bottom: 10px;\n                    color: color_new(grey, label_float);\n                    line-height: 1;\n                }\n\n                &-value {\n                    font-size: 14px;\n                    line-height: 1.5;\n                    color: color_new(grey, label);\n                    max-height: 18px;\n                    width: 100%;\n                    display: block;\n                    position: relative;\n                    input[type=\"text\"], \n                    input[type=\"password\"],\n                    ng-select {\n                        border: none;\n                        color: color_new(grey, label);\n                        font-size: 14px;\n                        margin: 0;\n                        padding: 0;\n                        font-family: $font-family-fsalbert-regular;\n                        float: left;\n                        height: 100%;\n                        line-height: 1;\n                        &:not(.disabled) {\n                            border-bottom: 1px solid color_new(grey, dim);\n                            max-height: inherit;\n                            @media not all and (min-resolution:.001dpcm) {\n                                max-height: 25px;\n                                height: 25px;\n                            }\n                        }\n                    }\n                    ng-select {\n                        height: 18px;\n                    }\n                    language-dropdown,\n                    .flag-holder {\n                        height: inherit;\n                    }\n                    language-dropdown,\n                    input[type=\"text\"], input[type=\"password\"],\n                    ng-select {\n                        width: 100%;\n                    }\n                    .partial-disabled {\n                        border-bottom: 1px solid color_new(grey, dim);\n                        cursor: not-allowed;\n                        pointer-events: none;\n                    }\n                    .fa-upload,\n                    .fa-download {\n                        position: absolute;\n                        right: 0.4em;\n                        bottom: 3px;\n                        color: color_new(blue, diversey_blue);\n                        cursor: pointer;\n                    }\n                    .custom-file-upload {\n                        border: none;\n                        padding: 0px;\n                        background: none;\n                    }\n                }\n                &-value-wrap {\n                    margin-bottom: 30px;\n                    @include flex(column);\n                }\n                &-error {\n                    margin: 0px;\n                    color: color_new(red, error);\n                    font-size: 12px;\n                    margin-top: 10px;\n                    span {\n                        display: block;\n                        line-height: 1;\n                    }\n                }\n            }\n            .fa-upload,\n            .fa-download {\n                color: color_new(blue, diversey_blue);\n            }\n            .hierarchy-dropdown {\n                width: 80%;\n                display: flex;\n            }\n            &--button {\n                flex-direction: row;\n                justify-content: space-between;\n                align-items: flex-end;\n                margin: 10px 0 5em;\n                &-wrapper {\n                    display: flex;\n                    flex-grow: 1;\n                    &:not(:first-child),\n                    &:first-child:last-child {\n                        justify-content: flex-end;\n                    }\n                }\n            }\n        }\n    }\n    .btn {\n        width: auto;\n        margin-right: 10px;\n        text-transform: uppercase;\n        background: transparent;\n        font-family: $font-family-fsalbert-bold;\n        cursor: pointer;\n        font-size: 12px;\n        padding: 8px 20px 4px;\n        color: color_new(blue, diversey_blue);\n        border: 1px solid color_new(blue, diversey_blue);\n        line-height: 1;\n        transition: all 0.2s ease;\n        &:last-child {\n            margin-right: 0;\n        }\n        &:hover {\n            box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);\n        }\n        &.disabled {\n            cursor: not-allowed;\n            user-select: none;\n            border: 1px solid color_new(grey, button_disable);\n            background-color: color_new(grey, button_disable);\n            pointer-events: none;\n            color: color_new(white, base);\n        }\n    }\n    .btn-save {\n        background-color: color_new(blue, diversey_blue);\n        color: color_new(white, base);\n    }\n    &.add-edit-page {\n        background: color_new(white, background_off_white);\n        .view__section:not(.view__section--button) {\n            background-color: color_new(white, base);\n            padding: 20px 50px 0px 50px;\n            margin-bottom: 10px;\n        }\n        .view__header {\n            padding: 0px 50px 0px 50px;\n        }\n    }\n}\n\n.select-dropdown-arrow {\n    &.active {\n        &:after {\n            transition: 0.5s all cubic-bezier(0.18, 0.89, 0.32, 1.28);\n            transform: rotate(180deg);\n        }\n    }\n    &:after {\n        content: \"\";\n        width: 0;\n        height: 0;\n        border-left: 5px solid transparent;\n        border-right: 5px solid transparent;\n        border-top: 5px solid color_new(blue, diversey_blue);\n        position: absolute;\n        top: 40%;\n        right: 3%;\n        transition: 0.4s all cubic-bezier(0.18, 0.89, 0.32, 1.28);\n    }\n}\n\n.select-dropdown {\n    position: relative;\n    width: 100%;\n    cursor: pointer;\n    display: flex;\n    @extend .select-dropdown-arrow;\n    border-bottom: 1px solid color_new(grey, dim);\n    height: 18px;\n    @media not all and (min-resolution:.001dpcm) {\n        height: 25px;\n    }\n    .label {\n        color: color_new(grey, label);\n        font-size: 14px;\n        padding-right: 3em;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 100%;\n        line-height: 1;\n    }\n    .label-placeholder {\n        font-size: 12px;\n        color: color_new(grey, dim);\n    }\n    .select-label {\n        position: relative;\n        background: color_new(white, background_off_white);\n        input[type=\"search\"] {\n            padding: 8px 8px 8px 30px;\n            margin: 0;\n            font-size: 12px;\n            width: 100%;\n            border: none;\n            background: color_new(white, background_off_white);\n            appearance: none;\n            line-height: 1;\n        }\n    }\n    .fa-search {\n        position: absolute;\n        left: 8px;\n        top: 22%;\n        color: color_new(grey, label_float);\n        font-size: 13px;\n    }\n    &.active {\n        .select-dropdown-wrapper {\n            display: block;\n        }\n    }\n    .select-dropdown-wrapper {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        display: none;\n        width: 100%;\n        background: color_new(white, base);\n        font-weight: normal;\n        box-shadow: 0px 3px 3px 1px rgba(0, 0, 0, 0.1);\n        border-top: 1px solid rgba(0, 0, 0, 0.08);\n        z-index: 10;\n        width: 100%;\n        left: 0;\n        top: 100%;\n    }\n    .fixed-height {\n        height: auto;\n        max-height: 200px;\n        overflow-y: scroll;\n        overflow-x: hidden;\n    }\n    .select-item {\n        padding: 10px 10px 8px;\n        display: flex;\n        justify-content: space-between;\n        cursor: pointer;\n        width: 100%;\n        &:hover {\n            background-color: color_new(white, background_off_white);\n        }\n        label {\n            font-size: 14px;\n            word-wrap: break-word;\n            display: block;\n            cursor: pointer;\n            user-select: none;\n        }\n    }\n}\n\ninput::-webkit-input-placeholder {\n    font-size: 12px;\n}\n\ninput::-moz-placeholder {\n    font-size: 12px;\n}\n\ninput::-ms-input-placeholder  {\n    font-size: 12px;\n}\n","// ==== flex related ====\n//for displaying flex with optional direction\n@mixin flex($direction: row) {\n    display: flex;\n    @if ($direction==col) {\n        flex-direction: column;\n    }\n    @else if ($direction==row-r) {\n        flex-direction: row-reverse;\n    }\n    @else if ($direction==col-r) {\n        flex-direction: column-reverse;\n    }\n    @else {\n        flex-direction: $direction;\n    }\n}\n\n@mixin arrow-down($color, $position: 95% 45%) {\n    // background-image: url('data:image/svg+xml;utf8,<svg fill=\"#{$color}\" height=\"1024\" width=\"767.5\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 384l383.75 383.75L767.5 384H0z\"/></svg>');\n    @if $color==$color_background-blue {\n        background-image: url(\"/assets/images/dropdown-arrow.png\");\n    }\n    @else if $color==$white {\n        background-image: url(\"/assets/images/triangle-down-white.png\");\n    }\n    @else if $color==$color_landing_tile {\n        background-image: url(\"/assets/images/triangle-down-white.png\");\n    }\n    @else {\n        background-image: url(\"/assets/images/dropdown-arrow.png\");\n    }\n    background-repeat: no-repeat; // background-size: 8px 14px;\n    background-size: auto;\n    background-position: $position;\n    background-color: $white;\n}\n\n//for justify-content on flex conatiners\n@mixin flex-jc($arg: start) {\n    @if ($arg==start) {\n        justify-content: flex-start;\n    }\n    @else if ($arg==end) {\n        justify-content: flex-end;\n    }\n    @else if ($arg==center) {\n        justify-content: center;\n    }\n    @else if ($arg==sb) {\n        justify-content: space-between;\n    }\n    @else if ($arg==sa) {\n        justify-content: space-around;\n    }\n    @else {\n        justify-content: $arg;\n    }\n}\n\n//for align-items on flex conatiners\n@mixin flex-ai($arg: stretch) {\n    @if ($arg==start) {\n        align-items: flex-start;\n    }\n    @else if ($arg==end) {\n        align-items: flex-end;\n    }\n    @else if ($arg==center) {\n        align-items: center;\n    }\n    @else if ($arg==base) {\n        align-items: baseline;\n    }\n    @else {\n        align-items: $arg;\n    }\n}\n\n//for align-self on flex children\n@mixin flex-as($arg: start) {\n    @if ($arg==start) {\n        align-self: flex-start;\n    }\n    @else if ($arg==end) {\n        align-self: flex-end;\n    }\n    @else if ($arg==base) {\n        align-self: baseline;\n    }\n    @else {\n        align-self: $arg;\n    }\n}\n\n//for flex-wrap on flex conatiners\n@mixin flex-wrap($arg: w) {\n    @if ($arg==w) {\n        flex-wrap: wrap;\n    }\n    @else if ($arg==wr) {\n        flex-wrap: wrap-reverse;\n    }\n    @else if ($arg==n) {\n        flex-wrap: nowrap;\n    }\n    @else {\n        flex-wrap: $arg;\n    }\n}\n\n// ==== margin, padding & border related ====\n//for padding\n@mixin pad($size,\n$side: all,\n$unit: px) {\n    @if ($side==all) {\n        padding: #{$size}px;\n    }\n    @else {\n        @if $side==v {\n            @include pad($size,\n            t,\n            $unit);\n            @include pad($size,\n            b,\n            $unit);\n        }\n        @else if $side==h {\n            @include pad($size,\n            l,\n            $unit);\n            @include pad($size,\n            r,\n            $unit);\n        }\n        @else if $side==t {\n            padding-top: #{$size}#{$unit};\n        }\n        @else if $side==r {\n            padding-right: #{$size}#{$unit};\n        }\n        @else if $side==b {\n            padding-bottom: #{$size}#{$unit};\n        }\n        @else if $side==l {\n            padding-left: #{$size}#{$unit};\n        }\n    }\n}\n\n//for margin\n@mixin mar($size,\n$side: all,\n$unit: px) {\n    @if ($side==all) {\n        margin: #{$size}px;\n    }\n    @else {\n        @if $side==v {\n            @include mar($size,\n            t,\n            $unit);\n            @include mar($size,\n            b,\n            $unit);\n        }\n        @else if $side==h {\n            @include mar($size,\n            l,\n            $unit);\n            @include mar($size,\n            r,\n            $unit);\n        }\n        @else if $side==t {\n            margin-top: #{$size}#{$unit};\n        }\n        @else if $side==r {\n            margin-right: #{$size}#{$unit};\n        }\n        @else if $side==b {\n            margin-bottom: #{$size}#{$unit};\n        }\n        @else if $side==l {\n            margin-left: #{$size}#{$unit};\n        }\n    }\n}\n\n@mixin font-face($name,\n$weight: normal,\n$style: normal) {\n    @font-face {\n        font-family: $name;\n        font-style: $style;\n        font-weight: $weight;\n        @content;\n    }\n}\n\n@mixin font($name,\n$size,\n$unit: rem,\n$weight: 300) {\n    font-family: $name;\n    font-size: $size + $unit;\n    font-weight: $weight;\n}\n\n@mixin dropdown-menu($placement: l) {\n    .dropdown-menu {\n        @if ($placement==l) {\n            left: 0;\n        }\n        @else if($placement==r) {\n            right: 0;\n        }\n        @content;\n    }\n}\n","\n// Global color Variables.\n\n$white: #FFFFFF;\n$black: #000;\n$color_skyblue: rgba(20,139,188,0.2);\n$body-bg-color: #ececec;\n$light-grey: #e0e0e0;\n$temp-base-font-color:\t#55696B;\n$host-primary-color: #009dda;\n$breadcrumb-border-color: #d8d8d8;\n$color_darkskyblue: #009ddb;\n$color-red :#F00;\n$color_green: #90c48f;\n$color_btn_red: #E36A79;\n$color_summary_block: #f8f8f8;\n$color_lightblue: #99d8f1;\n$color_summary-label: #999F9F;\n$color_summary-value: #3D4953;\n$color_realtime-label: #7d8c8e;\n$color_realtime-value: #4a6062;\n$color_realtime-image: #eeeeee;\n$color_realtime-border: #e7e7e7;\n$color_background-blue: #008998;\n$color-smoke-white: #f4f4f4;\n$color-light-grey: #ccc;\n$color_landing_tile: #58B3BE;\n\n//base font-face source path\n$base-font-path: \"../assets/font/\";\n\n//default font-size (in px)\n$base-font-size: 10;\n\n//default font-family\n$font-family-arial: 'arial';\n$base-font-family: 'FSAlbertArabic-Regular';\n\n\n//new design\n$font-family-fsalbert-regular: 'FSAlbertArabic-Regular';\n$font-family-fsalbert-thin: 'FSAlbertArabic-Thin';\n$font-family-fsalbert-light: 'FSAlbertArabic-Light';\n$font-family-fsalbert-bold: 'FSAlbertArabic-Bold';\n$font-family-fsalbert-extraBold: 'FSAlbertArabic-ExtraBold';\n\n//available font-faces\n$font-face-values: (fsalbert-regular: FSAlbertArabic, fsalbert-thin: FSAlbertArabic-Thin, fsalbert-light: FSAlbertArabic-Light, fsalbert-bold: FSAlbertArabic-Bold, fsalbert-extraBold: FSAlbertArabic-ExtraBold);\n\n//available font formats\n$font-formats: (eot: embedded-opentype, woff: woff, ttf: truetype);\n\n//multipurpose 0's, 1's & 2's\n$base-values: (0, 1, 2);\n\n//available width and height values in percentage\n$percentage-values: (33: 33.33, 66: 66.66, 1: 1, 5: 5, 10: 10, 15: 15, 20: 20, 25: 25, 30: 30, 35: 35, 40: 40, 45: 45, 50: 50, 55: 55, 60: 60, 65: 65, 70: 70, 75: 75, 80: 80, 85: 85, 90: 90, 95: 95, 100: 100);\n\n//available padding and margin values\n$pad-mar-values: (2, 3, 4, 5, 6, 8, 12, 16, 20, 24, 36);\n\n//available space side values\n$elem-sides: (all: all, v: vertical, h: horizontal, t: top, r: right, b: bottom, l: left);\n\n//available flex justify-content values for containers\n$flex-jc-values: (start: flex-start, end: flex-end, center: center, sb: space-between, sa: space-around, inherit: inherit);\n\n//available flex align-items values for containers & align-self values for flex children\n$flex-ai-as-values: (start: flex-start, end: flex-end, center: center, stretch: stretch, base: baseline, inherit: inherit);\n\n//available flex-direction values\n$flex-direction-values: (row: row, row-r: row-reverse, col: column, col-r: column-reverse);\n\n//available flex-wrap values\n$flex-wrap-values: (w: wrap, wr: wrap-reverse, n: nowrap);\n\n// Diversey Custom Font-Icon\n$icomoon-font-path: \"../assets/font\" !default;\n// $icomoon-font-path: \"/assets/font\" !default;\n\n$icon-administration: \"\\e903\";\n$icon-alarm: \"\\e904\";\n$icon-assets: \"\\e905\";\n$icon-caret-left: \"\\e906\";\n$icon-caret-right: \"\\e907\";\n$icon-cash: \"\\e908\";\n$icon-close: \"\\e901\";\n$icon-dropdown-arrow: \"\\e909\";\n$icon-energy-consumption: \"\\e913\";\n$icon-exclamation: \"\\e90a\";\n$icon-export: \"\\e90b\";\n$icon-fill-water: \"\\e914\";\n$icon-home: \"\\e900\";\n$icon-live: \"\\e90c\";\n$icon-non-compliant: \"\\e90d\";\n$icon-options: \"\\e915\";\n$icon-parameters: \"\\e90e\";\n$icon-reports: \"\\e90f\";\n$icon-rinse-water: \"\\e916\";\n$icon-search: \"\\e910\";\n$icon-share: \"\\e911\";\n$icon-tick: \"\\e912\";\n$icon-washcycles: \"\\e902\";\n$icon-washcycles2: \"\\e917\";\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
